import { isBlockedChatMediaFile } from '@/Utils/safeChatMedia';

import compressImage from './compressImages';

type ProcessMediaResult = {
    mediaArray: Array<{
        lastModified: number;
        lastModifiedDate?: Date;
        name: string;
        size: number;
        type: string;
        src: string;
        file: File;
    }>;
    rejectedNames: string[];
};

const processMedia = async (
    filesObject: FileList | File[],
): Promise<ProcessMediaResult> => {
    const empty: ProcessMediaResult = { mediaArray: [], rejectedNames: [] };
    if (!filesObject?.length || filesObject?.length === 0) {
        return empty;
    }
    const mediaArray: ProcessMediaResult['mediaArray'] = [];
    const rejectedNames: string[] = [];

    for (let i = 0; i < filesObject.length; i++) {
        const raw = filesObject[i];
        if (!raw) {
            continue;
        }

        if (isBlockedChatMediaFile({ name: raw.name, type: raw.type })) {
            rejectedNames.push(raw.name);
            continue;
        }

        const mime = raw.type || '';
        let itemType = '';

        if (mime.startsWith('image/')) {
            const compressedFile = await compressImage(raw);
            mediaArray.push({
                lastModified: compressedFile.lastModified,
                lastModifiedDate: compressedFile.lastModifiedDate,
                name: compressedFile.name,
                size: compressedFile.size,
                type: compressedFile.type,
                src: URL.createObjectURL(compressedFile),
                file: compressedFile,
            });
        } else {
            itemType = mime;
            if (mime && mime.startsWith('video/')) {
                itemType = mime || 'video/mp4';
            }

            const blob = new Blob([raw], {
                type: mime || 'application/octet-stream',
            });
            const blobUrl = URL.createObjectURL(blob);

            mediaArray.push({
                lastModified: raw.lastModified,
                name: raw.name,
                size: raw.size,
                type: itemType || 'application/octet-stream',
                src: blobUrl,
                file: raw,
            });
        }
    }
    return {
        mediaArray,
        rejectedNames,
    };
};
export default processMedia;
